export default function throttle(method, delay, context) {
  var timer = null;
  return function () {
    var args = arguments;
    var self = this;
    clearTimeout(timer);
    timer = setTimeout(function () {
      method.apply(context || self, args);
    }, delay || 100);
  };
}